import { useState, useEffect, Fragment, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems, selectAddStatus } from "src/modules/spItems/selectors";
import { getItems } from "src/modules/spItems/actions";
import Form from "src/components/Form";
import {
  ClosePanelBtnMobile,
  DrawerComponent,
  Modal,
} from "src/components/DialogComponent";
import Loading from "src/components/Loading";
import { fieldsInAddActionСomponent } from "../constants";
import { AddButton } from "src/components/ui-icons/buttons";
import TGButton from "src/components/ui/TGButton";
import {
  myTaskActionsHistoryListName,
  MyTaskActionsListFieldsType,
  myTaskActionsListName,
  myTasksTagsListName,
} from "src/api/config/myTasksActions.config";
import { TooltipItem } from "src/utils/Tooltip";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import { addItemRequest, getItemsRequest } from "src/modules/spItems/api";
import { myTaskMeetingsListName } from "src/api/config/meetings.config";
import { addUsers } from "src/modules/users/actions";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import moment from "moment";
import { emailsSender, siteUrl } from "src/api/config";
import { emailAPI } from "src/utils/api.utils";
import { actionsStatus, isStrapi } from "src/api/config/systemSwitch";
const { sendEmail } = emailAPI();

const AddActionInComponent = ({
  typeModule,
  idModule,
  CustomStyles,
  customTypes,
  viewMode,
  readOnly,
  filters,
  merge = true,
  hasAddAction,
  hideMobileList = false,
  noUsersRequest = false,
  mobileModalMode = false,
  mobileModalZIndex = 120,
  typeForm,
  setUpdateActionRenderMainPage,
  updateActionRenderMainPage
}: {
  typeModule: string;
  idModule: number | string;
  CustomStyles: string;
  customTypes?: string;
  viewMode?: boolean;
  readOnly?: boolean;
  filters?: Record<string, any>;
  merge?: boolean;
  hasAddAction?: (state: any) => void;
  hideMobileList?: boolean;
  noUsersRequest?: boolean;
  mobileModalMode?: boolean;
  mobileModalZIndex?: number;
  typeForm?: string;
  setUpdateActionRenderMainPage?: any;
  updateActionRenderMainPage?: boolean
}) => {
  const dispatch = useAppDispatch();
  const [addAction, setAddAction] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [formData, setFormData] = useState<any>(null);
  const baseFields = useMemo(() => {
    return fieldsInAddActionСomponent.map((field: any) => ({
      ...field,
      width: mobileModalMode ? "w-full" : field.width,
    }));
  }, [mobileModalMode]);
  const [listsFields, setListsFields] = useState(baseFields);
  const [customLoading, setCustomLoading] = useState(false);
  const actions: MyTaskActionsListFieldsType[typeof myTaskActionsListName][] = useAppSelector((state) =>
    selectItems(state, myTaskActionsListName)
  );
  const statusAddAction = useAppSelector((state) => selectAddStatus(state, myTaskActionsListName));
  const users: any = useAppSelector(selectUsers);
  const [defaultValues, setDefaultValues] = useState<any>({
    Status: actionsStatus.notStart,
    Description: typeModule !== 'MainPage' && `#${typeModule} ` || '',
  });
  const [meetings, setMeetings] = useState<any>([]);
  const [isSelectMeetings, setIsSelectMitings] = useState<any>(false);
  const [isSelectResponsible, setIsSelectResponsible] = useState<any>(false);
  const [query, setQuery] = useSearchParams();
  const currentUser = useAppSelector((state) => selectCurrentUser(state));
  const [getActions, setGetActions] = useState(false);
  const [dataActions, setDataActions] = useState<MyTaskActionsListFieldsType[typeof myTaskActionsListName][]>([]);
  const fieldsForm = listsFields;

  function getResponsibleOptions(meeting: any) {
    const owners = meeting.owners.split(",").map((owner: string) => {
      owner = owner.trim();
      return {
        value: (users[owner] && users[owner].email) || owner,
        label: (users[owner] && users[owner].displayName) || owner,
        avatar: (users[owner] && users[owner].avatar) || null,
      };
    });

    const participants =
      (meeting.participants &&
        meeting.participants.split(",").map((participant: string) => {
          participant = participant.trim();
          return {
            value: (users[participant] && users[participant].email) || participant,
            label: (users[participant] && users[participant].displayName) || participant,
            avatar: (users[participant] && users[participant].avatar) || null,
          };
        })) ||
      [];

    return _.uniqBy([...owners, ...participants], "value");
  }

  function getActionStatusColor(action: any) {
    return (
      (isStrapi && action.Status?.Metadata?.Color) ||
      action.Status_x003a_Color?.Title ||
      "#D1D5DB"
    );
  }

  function resetActionFormState() {
    setIsSelectMitings(false);
    setIsSelectResponsible(false);
    setFormData(null);
  }

  function completeAddActionFlow() {
    setCustomLoading(false);
    setGetActions((prev) => !prev);
    resetActionFormState();

    if (mobileModalMode) {
      setOpenCancelModal(false);
      setOpenSuccessModal(true);
      return;
    }

    setAddAction(false);
  }

  function closeMobileActionDrawer() {
    setAddAction(false);
    setOpenCancelModal(false);
    setOpenSuccessModal(false);
    resetActionFormState();
  }

  const openDocumentCard = (id: number) => {
    if (mobileModalMode) {
      const newSearchParams = new URLSearchParams(query);
      newSearchParams.set("actionCardMobile", id.toString());
      setQuery(newSearchParams);
      return;
    }
    window.open(`${siteUrl}/dashboard/3?actionCard=${id.toString()}`, "_blank");
  };

  useEffect(() => {
    setDefaultValues((prevState: any) => {
      return { ...prevState, Description: typeModule !== 'MainPage' && `#${typeModule} ` || '' }
    });
  }, [typeModule]);

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      const sendData = {
        Title: `Action #${Math.floor(Math.random() * 1000)}`,
        Responsible: formData.Responsible[0]["value"],
        Meeting: formData.Meeting.id,
        Description: (formData.Description && formData.Description.trim()) || "",
        Status: formData.Status,
        ImportantHashTag: typeModule !== 'MainPage' && `#${typeModule}_${idModule}` || '',
        AuthorEmail: currentUser.email.toLowerCase().trim(),
        ResponsibleEmail: formData.Responsible[0]["value"].toLowerCase().trim(),
        CreateActionDate: filters?.CreateActionDate.start || null,
        DateForDone:
          (typeof formData.DateForDone.startDate === "string" && new Date(formData.DateForDone.startDate)) ||
          formData.DateForDone.startDate,
      };

      if (
        moment(sendData.DateForDone).clone().startOf("day").unix() < moment(new Date()).clone().startOf("day").unix()
      ) {
        sendData["Status"] = actionsStatus.old;
      }
      const hashTags = sendData.Description.match(/(^|\W)(#[а-я\w][а-я\w-]*)/gi) || [];
      setCustomLoading(true);
      if (hashTags.length > 0) {
        getItemsRequest({ listName: myTasksTagsListName, filters: { Title: hashTags } }).then((results: any) => {
          const hashTagsInSP = [...results.items];
          let addHashTags: any = [];
          hashTags.forEach((tag: string) => {
            if (hashTagsInSP.filter((tagInSP: any) => tagInSP.Title === tag).length === 0) {
              addHashTags = [
                ...addHashTags,
                {
                  Title: tag,
                },
              ];
            }
          });
          if (addHashTags.length > 0) {
            addItemRequest({ listName: myTasksTagsListName, bodyArr: addHashTags, body: addHashTags[0] }).then(() => {
              addItemRequest({ listName: myTaskActionsListName, body: sendData, updateReducer: true }).then(
                (idAddActionCard) => {
                  const historyData = {
                    Title: `History action card #${idAddActionCard}`,
                    Action: idAddActionCard,
                    Status: actionsStatus.created, //Действие создано
                  };

                  // Если hasAddAction передан, вызываем его с историей данных
                  if (hasAddAction) {
                    hasAddAction(true);
                  }

                  addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData }).then((historyID) => {
                    setCustomLoading(false);
                    setAddAction(false);
                    setIsSelectMitings(false);
                    setIsSelectResponsible(false);
                    setFormData(null);
                    setGetActions(!getActions);
                    if (typeModule === 'MainPage') {
                      setUpdateActionRenderMainPage(!updateActionRenderMainPage);
                    }
                  });
                }
              );
            });
          } else {
            setCustomLoading(false);
            addItemRequest({ listName: myTaskActionsListName, body: sendData, updateReducer: true }).then(
              (idAddActionCard) => {
                // Если hasAddAction передан, вызываем его с историей данных
                if (hasAddAction) {
                  hasAddAction(true);
                }
                if (emailsSender) {
                  const timestamp = moment().unix();
                  const emailBody = {
                    Body: `Здравствуйте ${formData.Responsible[0]["label"]},<br/><br/>Сотрудник ${currentUser.displayName
                      } создал новое действие и назначил Вас ответственным за него:<br/><br/><ul><li>Совещание: <a href="${siteUrl}/dashboard/3/meetings?meetingCard=${formData.Meeting.id
                      }">${formData.Meeting.name
                      }</a></li><li>Описание действия: <a href="${siteUrl}/dashboard/3?actionCard=${idAddActionCard}">${formData.Description.trim()}</a></li><li>Срок: ${moment(
                        sendData.DateForDone
                      )
                        .clone()
                        .format("DD.MM.YYYY")}</li></ul>`,
                    DateToBeSentAt: moment().subtract(12, "hours").toDate(),
                    Title: "Мои Задачи | Создание нового действия",
                    Subject: "Мои Задачи | Создание нового действия",
                    Recepients: formData.Responsible[0]["value"],
                    CheckDoc: String(timestamp),
                  };
                  Promise.all([sendEmail(emailBody)]);
                }
                const historyData = {
                  Title: `History action card #${idAddActionCard}`,
                  Action: idAddActionCard,
                  Status: actionsStatus.created, //Действие создано
                };
                addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData }).then((historyID) => {
                  setCustomLoading(false);
                  setAddAction(false);
                  setIsSelectMitings(false);
                  setIsSelectResponsible(false);
                  setFormData(null);
                  setGetActions(!getActions);
                  if (typeModule === 'MainPage') {
                    setUpdateActionRenderMainPage(!updateActionRenderMainPage);
                  }
                });
              }
            );
          }
        });
      } else {
        setCustomLoading(false);
        addItemRequest({ listName: myTaskActionsListName, body: sendData, updateReducer: true }).then(
          (idAddActionCard) => {
            if (emailsSender) {
              const timestamp = moment().unix();
              const emailBody = {
                Body: `Здравствуйте ${formData.Responsible[0]["label"]},<br/><br/>Сотрудник ${currentUser.displayName
                  } создал новое действие и назначил Вас ответственным за него:<br/><br/><ul><li>Совещание: <a href="${siteUrl}/dashboard/3/meetings?meetingCard=${formData.Meeting.id
                  }">${formData.Meeting.name
                  }</a></li><li>Описание действия: <a href="${siteUrl}/dashboard/3?actionCard=${idAddActionCard}">${formData.Description.trim()}</a></li><li>Срок: ${moment(
                    sendData.DateForDone
                  )
                    .clone()
                    .format("DD.MM.YYYY")}</li></ul>`,
                DateToBeSentAt: moment().subtract(12, "hours").toDate(),
                Title: "Мои Задачи | Создание нового действия",
                Subject: "Мои Задачи | Создание нового действия",
                Recepients: formData.Responsible[0]["value"],
                CheckDoc: String(timestamp),
              };
              Promise.all([sendEmail(emailBody)]);
            }
            const historyData = {
              Title: `History action card #${idAddActionCard}`,
              Action: idAddActionCard,
              Status: actionsStatus.created, //Действие создано
            };
            addItemRequest({ listName: myTaskActionsHistoryListName, body: historyData }).then((historyID) => {
              setCustomLoading(false);
              setAddAction(false);
              setIsSelectMitings(false);
              setIsSelectResponsible(false);
              setFormData(null);
              setGetActions(!getActions);
              if (typeModule === 'MainPage') {
                setUpdateActionRenderMainPage(!updateActionRenderMainPage);
              }
            });
          }
        );
      }
    }
  }, [formData]);

  useEffect(() => {
    if (typeModule !== 'MainPage') {
      dispatch(
        getItems({
          listName: myTaskActionsListName,
          filters: { ImportantHashTag: `#${typeModule}_${idModule}*`, ...filters },
          merge: merge,
        })
      );
    }
  }, [getActions, typeModule]);

  useEffect(() => {
    if (meetings.length > 0) {
      const meeting =
        meetings.filter((meeting: any) => isSelectMeetings && meeting.id === isSelectMeetings.id)[0] || null;
      if (meeting) {
        let usersEmail: any = [];
        usersEmail = (meeting.owners && [
          ...usersEmail,
          ...meeting.owners.split(",").map((owner: string) => owner.trim()),
        ]) || [...usersEmail];
        usersEmail = (meeting.participants && [
          ...usersEmail,
          ...meeting.participants.split(",").map((participant: string) => participant.trim()),
        ]) || [...usersEmail];
        usersEmail = _.uniqWith(usersEmail, _.isEqual);
        if (usersEmail.length > 0) {
          dispatch(addUsers(usersEmail));
        }
      }
    }
  }, [isSelectMeetings, meetings]);

  useEffect(() => {
    if (meetings.length > 0) {
      const tempFieldsForm: any = baseFields.map((field: any) => ({ ...field }));
      const meeting =
        meetings.filter((meeting: any) => isSelectMeetings && meeting.id === isSelectMeetings.id)[0] || null;
      if (isSelectMeetings && !isSelectResponsible && meeting) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Responsible") {
            tempFieldsForm[i]["options"] = getResponsibleOptions(meeting);
          }
        }
      }
      if (!isSelectMeetings && isSelectResponsible) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Meeting") {
            tempFieldsForm[i]["options"] = meetings
              .filter(
                (meeting: any) =>
                  meeting.owners.indexOf(isSelectResponsible.value) !== -1 ||
                  (meeting.participants && meeting.participants.indexOf(isSelectResponsible.value) !== -1)
              )
              .filter((item: any) => item.status === "active")
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                  status: item.status,
                };
              });
            if (tempFieldsForm[i]["options"].length === 0) {
              tempFieldsForm[i]["options"] = [
                {
                  id: 0,
                  name: "Совещания не найдены",
                  owners: null,
                  participants: null,
                  available: false,
                },
              ];
            }
          }
        }
      }
      if (!isSelectMeetings && !isSelectResponsible) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Responsible") {
            tempFieldsForm[i]["options"] = [];
          }
          if (tempFieldsForm[i]["key"] === "Meeting") {
            tempFieldsForm[i]["options"] = meetings
              .filter((item: any) => item.status === "active")
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                };
              });
          }
        }
      }
      if (isSelectMeetings && isSelectResponsible) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Meeting") {
            tempFieldsForm[i]["options"] = meetings
              .filter(
                (meeting: any) =>
                  meeting.owners.indexOf(isSelectResponsible.value) !== -1 ||
                  (meeting.participants && meeting.participants.indexOf(isSelectResponsible.value) !== -1)
              )
              .filter((meeting: any) => meeting.id !== isSelectMeetings.id && meeting.status === "active")
              .map((item: any) => {
                return {
                  id: item.id,
                  name: item.name,
                  owners: item.owners,
                  participants: item.participants,
                  status: item.status,
                };
              });
            if (tempFieldsForm[i]["options"].length === 0) {
              tempFieldsForm[i]["options"] = [
                {
                  id: 0,
                  name: "Совещания не найдены",
                  owners: null,
                  participants: null,
                  available: false,
                },
              ];
            }
          }
          if (tempFieldsForm[i]["key"] === "Responsible" && meeting) {
            tempFieldsForm[i]["options"] = getResponsibleOptions(meeting);
          }
        }
      }
      setListsFields([...tempFieldsForm]);
    }
  }, [isSelectMeetings, isSelectResponsible, meetings, users, baseFields]);

  useEffect(() => {
    if (meetings.length === 0) {
      getItemsRequest({
        listName: myTaskMeetingsListName,
        viewFields: ["ID", "Title", "Owners", "Participants", "Status", "AdditionalFields"],
      }).then((result: any) => {
        const tempSelectMeetings = result.items.map((item: any) => {
          return {
            id: item.ID,
            name: item.Title,
            owners: item.Owners,
            participants: item.Participants,
            status: item.Status,
            fields: item.AdditionalFields,
          };
        });
        if (tempSelectMeetings.length > 0) {
          setMeetings([...tempSelectMeetings]);
        }
      });
    }
  }, [meetings]);

  useEffect(() => {
    const tempActions: MyTaskActionsListFieldsType[typeof myTaskActionsListName][] = _.uniqWith(actions, _.isEqual);
    setDataActions([...tempActions]);
  }, [actions]);

  return (
    <div
      className={twMerge(
        "relative overflow-x-visible sm:overflow-x-auto sm:shadow-md sm:rounded-lg",
        CustomStyles,
      )}
    >
      {typeModule !== 'MainPage' &&
      <table className="w-full mb-5 text-sm text-left text-gray-500 rtl:text-right hidden sm:table">
        <thead className="block pb-5 text-sm">
          <tr className="flex gap-5">
            <th style={{ width: "7.5%" }} scope="col">
              Дата создания
            </th>
            <th style={{ width: "45%" }} scope="col">
              Описание
            </th>
            <th style={{ width: "9.5%" }} scope="col">
              Совещание
            </th>
            <th style={{ width: "10%" }} scope="col">
              Срок выполнения
            </th>
            <th style={{ width: "12%" }} scope="col">
              Статус
            </th>
            <th style={{ width: "17%" }} scope="col">
              Ответственный
            </th>
          </tr>
        </thead>
          <tbody className="flex flex-col gap-5">
            {((statusAddAction === "LOADING" || customLoading) && (
              <tr>
                <td className="flex items-center justify-center w-full" colSpan={6}>
                  <Loading />
                </td>
              </tr>
            )) || (
                <>
                  {dataActions
                    .filter(
                      (action) =>
                        action.ImportantHashTag &&
                        action.ImportantHashTag.trim() === `#${typeModule}_${idModule}`.trim() &&
                        (!filters?.AuthorEmail ||
                          action.AuthorEmail?.toLowerCase().trim() === String(filters.AuthorEmail).toLowerCase().trim())
                    )
                    .map((action) => (
                      <tr
                        onClick={() => openDocumentCard(action.ID)}
                        key={action.ID}
                        className="flex gap-5 pb-5 break-all bg-white border-b cursor-pointer"
                      >
                        <td style={{ width: "7.5%" }}>
                          <span>{action.Created.format("DD.MM.YYYY")}</span>
                        </td>
                        <td style={{ width: "45%" }}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: action.Description.replace(
                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                '<span style="color: rgb(0,98,155)">$&</span>'
                              ),
                            }}
                          />
                        </td>
                        <td style={{ width: "9.5%" }}>
                          <span>{action.Meeting.Title}</span>
                        </td>
                        <td style={{ width: "10%" }}>
                          <span>{action.DateForDone.format("DD.MM.YYYY")}</span>
                        </td>
                        <td style={{ width: "12%" }}>
                          <div className="flex items-center w-full">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                              <circle
                                cx="5"
                                cy="5"
                                r="5"
                                fill={(isStrapi && action.Status.Metadata.Color) || action.Status_x003a_Color.Title}
                              />
                            </svg>
                            &nbsp;&nbsp;{action.Status.Title}
                          </div>
                        </td>
                        <td style={{ width: "17%" }}>
                          <div className="flex items-center w-full gap-2">
                            <UserAvatar
                              avatar={users[action.Responsible.Email] && users[action.Responsible.Email].avatar}
                              shortName={users[action.Responsible.Email] && users[action.Responsible.Email].shortName}
                              displayName={users[action.Responsible.Email] && users[action.Responsible.Email].displayName}
                              email={action.Responsible.Email}
                            />
                            <div className="flex flex-col items-start justify-center">
                              <span className="text-sm text-[#111928]">
                                {users[action.Responsible.Email] && users[action.Responsible.Email].displayName}
                              </span>
                              <span
                                className="text-sm text-[#637381]"
                                dangerouslySetInnerHTML={{
                                  __html: users[action.Responsible.Email] && users[action.Responsible.Email].jobTitle,
                                }}
                              />
                            </div>
                          </div>
                      </td>
                    </tr>
                  ))}
              </>
            )}
        </tbody>
      </table>}
      {addAction &&
        (mobileModalMode ? (
          <>
            <DrawerComponent
              zIndex={mobileModalZIndex}
              open={addAction}
              toggleDrawer={setAddAction}
              setOpenCustomModal={setOpenCancelModal}
              percentage="93"
            >
              <div className="flex flex-col shrink">
                <header className="flex items-center justify-between border-b p-6">
                  <h1 className="text-[16px] font-medium text-black">Добавить действие</h1>
                  <ClosePanelBtnMobile
                    hideXMarkIcon={false}
                    setOpenCustomModal={setOpenCancelModal}
                    toggleDrawer={setAddAction}
                  />
                </header>

                <div className="mobile-form px-6 py-6">
                  {statusAddAction === "LOADING" || customLoading ? (
                    <div className="my-5 flex w-full items-center justify-center">
                      <Loading />
                    </div>
                  ) : (
                    <Form
                      type="add_action_in_component"
                      setFormData={setFormData}
                      fieldsForm={fieldsForm}
                      setOpenCancelAddCard={setOpenCancelModal}
                      openCancelAddCard={openCancelModal}
                      textButtonSubmit="Сохранить действие"
                      defaultValues={defaultValues}
                      setIsSelectMitings={setIsSelectMitings}
                      setIsSelectResponsible={setIsSelectResponsible}
                      customTypes={customTypes}
                      isMobileModeAddInComponent={mobileModalMode}
                    />
                  )}
                </div>
              </div>
            </DrawerComponent>

            <Modal
              zIndex={mobileModalZIndex + 10}
              open={openSuccessModal}
              toggleDialog={setOpenSuccessModal}
              hideXMarkIcon={true}
              modalClassName="!min-h-0 !w-[calc(100vw-24px)] !min-w-0 rounded-xl py-5"
            >
              <header className="px-6 pb-2">
                <h2>Вы успешно сохранили форму</h2>
              </header>

              <div className="grow px-6 py-4">
                <p>Форма сохранена со всеми изменениями</p>
              </div>

              <footer className="mt-2 flex flex-col gap-3 border-t px-6 pt-4">
                <TGButton
                  color="bluedark"
                  className="h-[44px] w-full justify-center text-[14px]"
                  onClick={closeMobileActionDrawer}
                >
                  Закрыть
                </TGButton>
              </footer>
            </Modal>

            <Modal
              zIndex={mobileModalZIndex + 10}
              open={openCancelModal}
              toggleDialog={setOpenCancelModal}
              hideXMarkIcon={true}
              modalClassName="!min-h-0 !w-[calc(100vw-24px)] !min-w-0 rounded-xl py-5"
            >
              <header className="px-6 pb-2">
                <h2>Подтвердите действие</h2>
              </header>

              <div className="grow px-6 py-4">
                <p>
                  Вы уверены, что хотите закрыть окно? Вся введенная вами
                  информация будет сброшена. Заполните все обязательные поля,
                  чтобы сохранить действие.
                </p>
              </div>

              <footer className="mt-2 flex flex-col gap-3 border-t px-6 pt-4">
                <TGButton
                  color="bluedark"
                  className="h-[44px] w-full justify-center text-[14px]"
                  onClick={() => setOpenCancelModal(false)}
                >
                  Вернуться к действию
                </TGButton>
                <TGButton
                  className="h-[44px] w-full justify-center text-[14px]"
                  onClick={closeMobileActionDrawer}
                >
                  Закрыть без сохранения
                </TGButton>
              </footer>
            </Modal>
          </>
        ) : (
          <div className={twMerge(
            "w-full flex-col gap-4 tablet:gap-8 flex self-stretch rounded-lg",
            typeModule === "MainPage" ? "bg-white p-0 mb-0" : "bg-[#FFFFFF] tablet:bg-[#F3F4F6] p-0 tablet:p-5 mb-5"
          )}>
            <Form
              type="add_action_in_component"
              setFormData={setFormData}
              fieldsForm={fieldsForm}
              setOpenCancelAddCard={setAddAction}
              openCancelAddCard={addAction}
              textButtonSubmit="Сохранить действие"
              defaultValues={defaultValues}
              setIsSelectMitings={setIsSelectMitings}
              setIsSelectResponsible={setIsSelectResponsible}
              customTypes={customTypes}
              isMobileModeAddInComponent={mobileModalMode}
            />
          </div>
        ))}
      {typeModule !== 'MainPage' && !addAction && (
        <>
          {(!idModule && (
            <TooltipItem
              wrapperClassName="w-full"
              position="top"
              tooltipsText={twMerge(
                typeModule === "VPO" && "Сохраните несоответствие, чтобы добавить действия",
                typeModule === "5Почему" && "Сохраните инструмент, чтобы добавить действия",
                typeModule !== "VPO" &&
                typeModule !== "5Почему" &&
                typeModule !== "Предписание" &&
                "Сохраните форму, чтобы добавить действия",
                typeModule === "Предписание" && "Сохраните нарушение, чтобы добавить действия"
              )}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setAddAction(true);
                }}
                disabled={true}
                className="disabled:bg-[#E5E7EB] disabled:text-[#374151] disabled:cursor-not-allowed btn-white mb-5 w-full flex justify-center items-center py-3 px-6 rounded-md leading-[22px] shadow-custom text-[#00629B]"
              >
                <div className="mr-1.5">
                  <AddButton />
                </div>
                <span>{(typeForm && (typeForm === 'add_my_tasks_5way' || typeForm === '5way_card_my_tasks')) && 'Добавить немедленное корректирующее действие' || 'Добавить действие'}</span>
              </button>
            </TooltipItem>
          )) ||
            (!viewMode && (
              // <button
              //   onClick={(e) => {
              //     e.preventDefault();
              //     setAddAction(true);
              //   }}
              //   className="btn-white mb-0 sm:mb-5 w-full flex justify-center items-center py-[16px] sm:py-3 px-[16px] sm:px-6 rounded-md leading-[22px] shadow-custom text-[#00629B]"
              // >
              //   <div className="mr-1.5">
              //     <AddButton />
              //   </div>
              //   <span>{(typeForm && (typeForm === 'add_my_tasks_5way' || typeForm === '5way_card_my_tasks')) && 'Добавить немедленное корректирующее действие' || 'Добавить действие'}</span>
              // </button>
              <>
                {typeModule === '5Почему' &&
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setAddAction(true);
                    }}
                    className="btn-yellow mb-5 w-full flex justify-center items-center py-3 px-6 rounded-md leading-[22px] shadow-custom text-[#00629B] gap-2"
                  >
                    <span className="w-full text-center sm:text-left">Добавить действие</span>
                    <AddButton />
                  </button> ||
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setAddAction(true);
                    }}
                    className="btn-white mb-5 w-full flex justify-center items-center py-3 px-6 rounded-md leading-[22px] shadow-custom text-[#00629B]"
                  >
                    <div className="mr-1.5">
                      <AddButton />
                    </div>
                    <span className="w-full text-center sm:text-left">Добавить действие</span>
                  </button>
                }
              </>
            ))}
        </>
      )}
      {/* Эта секция отображается только на мобильных устройствах */}
      {!hideMobileList &&
        ((statusAddAction === "LOADING" || customLoading) ||
          dataActions.some(
            (action) =>
              action.ImportantHashTag &&
              action.ImportantHashTag.trim() === `#${typeModule}_${idModule}`.trim(),
          )) && (
          <div className="w-full mt-[8px] text-sm text-left text-gray-500 rtl:text-right sm:hidden">
            {(statusAddAction === "LOADING" || customLoading) ? (
              <div className="flex items-center justify-center w-full">
                <Loading />
              </div>
            ) : (
              <div className="relative">
                {dataActions
                  .filter(
                    (action) =>
                      action.ImportantHashTag &&
                      action.ImportantHashTag.trim() ===
                        `#${typeModule}_${idModule}`.trim(),
                  )
                  .map((action) => (
                    <div
                      className="relative cursor-pointer pl-[18px]"
                      key={action.ID}
                      onClick={() => openDocumentCard(action.ID)}
                    >
                      <div className="flex items-center w-fit absolute left-0 top-[8px]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="10"
                          viewBox="0 0 10 10"
                          fill="none"
                        >
                          <circle
                            cx="5"
                            cy="5"
                            r="5"
                            fill={getActionStatusColor(action)}
                          />
                        </svg>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: action.Description.replace(
                            /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                            '<span style="color: rgb(0,98,155)">$&</span>',
                          ),
                        }}
                      />
                      <div className="mt-[8px]">
                        <span>{`Срок ${action.DateForDone.format("DD.MM.YYYY")}`}</span>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}
      {typeModule === 'MainPage' && !addAction &&
        <button
          onClick={(e) => {
            e.preventDefault();
            setAddAction(true);
          }}
          className="btn-white w-full flex justify-center items-center py-3 px-6 rounded-md leading-[22px] shadow-custom text-[#00629B]"
        >
          <div className="mr-1.5">
            <AddButton />
          </div>
          <span>Добавить действие</span>
        </button>
      }
    </div>
  );
};

export default AddActionInComponent;
